/* eslint-disable max-len */
import { computed, ref } from 'vue';
import { intersection } from 'lodash';
function filterFromTimeline(trackList, filter, checkAttributes) {
    const tracksFound = [];
    const skipRest = false;
    let foundFrame = -1;
    let startFrame;
    let endFrame;
    trackList.forEach((context) => {
        const track = context.annotation;
        if (skipRest) {
            return;
        }
        // Find a track which matches the specifications
        const vals = [];
        if (filter.frameRange) {
            [startFrame, endFrame] = filter.frameRange;
            if (startFrame !== undefined && endFrame !== undefined) {
                if (track.begin > startFrame && track.end < endFrame) {
                    vals.push(true);
                }
            }
        }
        const types = track.confidencePairs.map((item) => item[0]);
        const typeFilterIncludesAll = filter.typeFilter?.includes('all') ?? false;
        if (filter.typeExclude && filter.typeExclude.length > 0) {
            const overlap = intersection(types, filter.typeExclude);
            if (overlap.length > 0) {
                vals.push(false); // explicitly exclude if any match
            }
        }
        if (typeFilterIncludesAll) {
            // If 'all' is present, all types are allowed and exclusion is disabled
            vals.push(true);
        }
        else if (filter.typeFilter && filter.typeFilter.length > 0) {
            vals.push(intersection(types, filter.typeFilter).length > 0);
        }
        if (filter.confidenceFilter !== undefined) {
            const confidenceVals = track.confidencePairs.map((item) => item[1]);
            vals.push(confidenceVals[0] > filter.confidenceFilter);
        }
        //attribute checking
        if (filter.attributes) {
            if (filter.attributes.track) {
                vals.push(checkAttributes(filter.attributes.track, track.attributes));
            }
            //Need a separate check for detection attributes
            if (filter.attributes.detection) {
                for (let i = 0; i < track.features.length; i += 1) {
                    const feature = track.features[i];
                    if (startFrame !== undefined) {
                        if (feature.frame >= startFrame) {
                            // eslint-disable-next-line no-continue
                            continue;
                        }
                        else if (feature.frame <= startFrame) {
                            // eslint-disable-next-line no-continue
                            continue;
                        }
                    }
                    if (feature.attributes) {
                        const result = checkAttributes(filter.attributes.detection, feature.attributes);
                        if (result) {
                            vals.push(result);
                            if (startFrame) {
                                if (foundFrame < startFrame) {
                                    foundFrame = feature.frame;
                                }
                            }
                            else {
                                foundFrame = feature.frame;
                                break;
                            }
                        }
                    }
                }
            }
        }
        if (vals.filter((item) => item).length === vals.length) {
            tracksFound.push(context);
        }
    });
    return tracksFound;
}
export default function UseTimelineFilters({ enabledTracks, selectedTrackIds, typeStyling, checkAttributes, }) {
    const timelines = ref([]);
    const loadFilterTimelines = (data) => {
        timelines.value = data;
    };
    const enabledTimelines = computed(() => (timelines.value.filter((item) => (item.enabled))));
    // Create a mapping between timeline name and eventChart data for the timeline
    const eventChartDataMap = computed(() => {
        const eventChartMap = {};
        const mapfunc = typeStyling.value.color;
        const selectedTrackIdsValue = selectedTrackIds.value;
        timelines.value.forEach((timeline) => {
            if (timeline.enabled) {
                // we calculate which tracks meet the criteria
                eventChartMap[timeline.name] = { muted: false, values: [] };
                const filteredTracks = filterFromTimeline(enabledTracks.value, timeline, checkAttributes);
                filteredTracks.forEach((filtered) => {
                    // We only want to use Tracks that match the filter specified for the timelines that exist.
                    const { annotation: track } = filtered;
                    const { confidencePairs } = track;
                    let markers = [];
                    if ('featureIndex' in track) {
                        markers = track.featureIndex.map((i) => ([i, track.features[i].interpolate || false]));
                    }
                    if (confidencePairs.length) {
                        const trackType = track.getType(filtered.context.confidencePairIndex)[0];
                        eventChartMap[timeline.name].values.push({
                            id: track.id,
                            name: `Track ${track.id}`,
                            type: trackType,
                            color: mapfunc(trackType),
                            selected: selectedTrackIdsValue.includes(track.id),
                            range: [track.begin, track.end],
                            markers,
                        });
                    }
                });
            }
        });
        return eventChartMap;
    });
    return {
        eventChartDataMap, timelines, loadFilterTimelines, enabledTimelines,
    };
}
